var _style, _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidneyWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000155125668629485965660000008622555123730678959_);}\r\n\t.st1{fill:#105742;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 6.1,
    y: 3,
    width: 39.4,
    height: 42.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009574623654036608600000016103193369599557028_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000009574623654036608600000016103193369599557028_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.8,45.5c-1.4,0-2.7-0.2-4.1-0.6c-1.3-0.4-2.5-1-3.6-1.7c-1.1-0.8-2-1.9-2.6-3.3s-1-3.1-1-5 c0-0.9,0.2-1.7,0.7-2.5c0.5-0.8,1.1-1.5,1.8-2.1c0.7-0.6,1.4-1.2,2.2-1.8c0.7-0.6,1.4-1.2,2.1-1.9c0.7-0.7,1.1-1.4,1.4-2.1 c-3.3,0.4-6,1.6-8,3.5s-3,4.6-3,8c0,2.5,0.4,4.8,1.3,6.9H6.9c-0.6-2.2-0.8-4.4-0.8-6.7c0-3.4,0.7-6.3,2-8.8 c1.3-2.5,3.2-4.4,5.5-5.8c-0.6-0.5-1.1-0.9-1.6-1.4c-1.7-1.5-3.2-3.3-4.4-5.1l4.3-3.9c1,2,2.4,3.9,4.2,5.6 c0.9,0.8,1.8,1.4,2.7,1.8c0.9,0.3,1.9,0.5,3,0.6c-0.3-0.4-0.9-1.2-1.8-2.2c-0.9-1-1.5-1.9-2-2.8c-0.4-0.9-0.6-1.8-0.6-2.9 c0-1.3,0.3-2.4,1-3.5C19,6.5,20,5.6,21.1,5c1.1-0.6,2.4-1.1,3.6-1.5C25.9,3.2,27.3,3,28.6,3c2.3,0,4.5,0.5,6.6,1.5 c2,1,3.9,2.4,5.4,4.1c1.5,1.7,2.7,3.8,3.6,6.3c0.9,2.5,1.3,5.2,1.3,8c0,2.8-0.6,5.7-1.8,8.5c-1.2,2.8-2.7,5.2-4.6,7.2 c-1.8,2-4,3.7-6.4,5C30.4,44.8,28,45.5,25.8,45.5L25.8,45.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneyWhite);
export default __webpack_public_path__ + "static/media/kidney_white.59c72b42.svg";
export { ForwardRef as ReactComponent };